/**
 * @file routes/_app/settings/verification-qualifications.tsx
 * @description 驗證資格字典維護頁（主體類型）。
 *
 * 對應 clients.verificationQualification（單選）。字典項會出現在
 * 「組織客戶檔案 → 編輯客戶 → 驗證資格」下拉選單。
 * 停用後新增/編輯客戶時不會出現該選項，但既有客戶資料仍保留原值。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/verification-qualifications')({
  component: VerificationQualificationsPage,
});

/** 驗證資格維護頁 */
function VerificationQualificationsPage() {
  return (
    <LookupAdminPage
      resource="verification-qualifications"
      resourceLabel="驗證資格"
      description="主體類型（自然人 / 農場 / 產銷班 / 學校 / 法人或團體 / 領有工廠登記證或商業登記證明文件者）。客戶建檔單選。"
      nameMaxLength={50}
    />
  );
}
